module.exports = __webpack_public_path__ + "static/media/HDaserie340wilo.7e525cab.jpg";